import axios from "../../axiosInstance"
import { getUserId } from "../../components/Utils/Common";

const Invoice_base_api = "/im/ob/import"
class InvoiceService{
    insertCommercialItemPreAlertNo(details){
        return axios.post(Invoice_base_api+'/insertCommercialItemPreAlertNo',details);
    }
    getSupplierDetails(details){
        return axios.post(Invoice_base_api+'/getSupplierDetails',details);
    }
    getCurrency(details){
        return axios.post(Invoice_base_api+'/getCurrency',details);
    }
    getTransactionMode(details){
        return axios.post(Invoice_base_api+'/getTransactionMode',details);
    }
    getpaymentTerms(details){
        return axios.post(Invoice_base_api+'/getpaymentTerms',details);
    }
    getValuationMethod(details){
        return axios.post(Invoice_base_api+'/getValuationMethod',details);
    }
    getInvoiceTerms(details){
        return axios.post(Invoice_base_api+'/getInvoiceTerms',details);
    }
    insertSvb(details){
        return axios.post(Invoice_base_api+'/insertSvb',details);
    }
    getSvb(InvoiceId){
        return axios.get(Invoice_base_api+'/getSvb?InvoiceId='+InvoiceId);
    }
    updateSvb(InvoiceId,details){
        return axios.put(Invoice_base_api+'/updateSvb?InvoiceId='+InvoiceId,details);//body+param
    }
    deleteSvb(svbId){
        return axios.delete(Invoice_base_api+'/deleteSvb?InvoiceId='+svbId);
        
    }insetThirdparty(details){
        return axios.post(Invoice_base_api+'/import_Invoice_insertThirdParty',details);
    }
    getThirdparty(details){
        return axios.post(Invoice_base_api+'/import_Invoice_getThirdParty',details);
    }
    updateThirdParty(details){
        return axios.put(Invoice_base_api+'/import_Invoice_updateThirdParty',details);
    }
    deleteThirdParty(thirdPartyId){
        return axios.delete(Invoice_base_api+'/import_Invoice_deleteThirdParty?InvoiceId='+thirdPartyId);
    }
    insertSeller(details){
        return axios.post(Invoice_base_api+'/insertSeller',details);//pure insert
    }
    getSeller(InvoiceId){
        return axios.get(Invoice_base_api+'/getSeller?InvoiceId='+InvoiceId)//pure get
    }
    updateSeller(details){
    return axios.put(Invoice_base_api+'/updateSeller',details) //pure update
    }
    deleteSeller(sellerId){
        return axios.delete(Invoice_base_api+'/deleteSeller?InvoiceId='+sellerId)
    }
    insertBroker(details){
        return axios.post(Invoice_base_api+'/insertBroker',details)
    }
    getBroker(InvoiceId){
        return axios.get(Invoice_base_api+'/getBroker?InvoiceId='+InvoiceId)
    }
    updateBroker(details){
        return axios.put(Invoice_base_api+'/updateBroker',details)
    }
    deleteBroker(brokerId){
        return axios.delete(Invoice_base_api+'/deleteBroker?InvoiceId='+brokerId)
    }
    insertDiscount(details){
        return axios.post(Invoice_base_api+'/insertDiscount',details)
    }
    getDiscount(InvoiceId){
        return axios.get(Invoice_base_api+'/getDiscount?invoiceId='+InvoiceId)
    }
    updateDiscount(details){
        return axios.put(Invoice_base_api+'/updateDiscount',details)
    }
    deleteDiscount(discountId){
        return axios.delete(Invoice_base_api+'/deleteDiscount?InvoiceId='+discountId)
    }
    insertMisc(details){
        return axios.post(Invoice_base_api+'/insertMisc',details)
    }
    getMisc(InvoiceId){
        return axios.get(Invoice_base_api+'/getMisc?InvoiceId='+InvoiceId)
    }
    updateMisc(details){
        return axios.put(Invoice_base_api+'/updateMisc',details)
    }
    deleteMisc(miscId){
        return axios.delete(Invoice_base_api+'/deleteMisc?InvoiceId='+miscId)
    }
    insertCommercialInvoiceAlertNo(details){
        return axios.post(Invoice_base_api+'/insertCommercialInvoiceAlertNo',details)
    }
    getCommercialInvoice(details){
        return axios.post(Invoice_base_api+'/getCommercialInvoice',details)
    }
    insertCommercialInvoice(details){
        return axios.post(Invoice_base_api+'/insertCommercialInvoice',details)
    }
    getCommercialInvoiceAssign(details){
        return axios.post(Invoice_base_api+'/getCommercialInvoiceAssign',details)
    }
    updateCommercialInvoice(details){
        return axios.put(Invoice_base_api+'/updateCommercialInvoice',details)
    }
    deleteCommercialInvoice(invoiceId){
        return axios.delete(Invoice_base_api+'/deleteCommercialInvoice?InvoiceId='+invoiceId)
    }
    updateJobFrgtInsDetails(details){
        return axios.put(Invoice_base_api+'/updateJobFrgtInsDetails',details)
    }
    getAutoBifurcateValue(details){
        return axios.post(Invoice_base_api+'/getAutoBifurcateValue',details)
    }
    calculateAutoBifurcateFrgInsValue(details){
        return axios.post(Invoice_base_api+'/calculateAutoBifurcateFrgInsValue',details)
    }
    insertDuplicateInvoiceImport(details){
        return axios.post(Invoice_base_api+'/insertDuplicateInvoiceImport',details)
    }
    excelDataUpload(job,file){
        let formData = new FormData();
        formData.append("file", file);
        return axios.post(Invoice_base_api+'/excelDataUpload?consignmentId='+job+'&createdBy='+getUserId(),formData)
    }
    getInvoiceErrorList(job_no){
        return axios.get(Invoice_base_api+'/getInvoiceErrorList?consignmentId='+job_no)
    }
    
}
export default new InvoiceService();